import type { Storage, StorageOptions } from "./types";

export class WebStorage implements Storage {
  private namespace: string;

  constructor(options: StorageOptions) {
    this.namespace = options.namespace;
  }

  private checkAvailable() {
    if (typeof window === "undefined" || !window.localStorage) {
      console.warn("WebStorage is not available");
      throw new Error("Window is not available for localStorage");
    }
    return true;
  }

  private getFullKey(key: string): string {
    return `${this.namespace}-${key}`;
  }

  set(key: string, value: string): Promise<void> {
    if (!this.checkAvailable()) {
      return Promise.resolve();
    }
    localStorage.setItem(this.getFullKey(key), value);
    return Promise.resolve();
  }

  get(key: string): Promise<string | null> {
    if (!this.checkAvailable()) {
      return Promise.resolve(null);
    }
    return Promise.resolve(localStorage.getItem(this.getFullKey(key)));
  }

  remove(key: string): Promise<void> {
    if (!this.checkAvailable()) {
      return Promise.resolve();
    }
    localStorage.removeItem(this.getFullKey(key));
    return Promise.resolve();
  }
}

export const createStorage = (options: StorageOptions): Storage => {
  return new WebStorage(options);
};
